import React, { useContext } from 'react';
import { Card, Grid, Title, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import {
  ResourceContext,
  StatisticContext,
} from '../../context/ContextWrapper';
import { AuthContext } from '../../context/AuthProvider';
import StatsPie from './StatsPie';
import StatsRequestedResources from './StatsRequestedResources';
import { STATISTICS_STATUS_ENUM } from '../../api_enums/STATISTICS_STATUS_ENUM';
import ResourceLegend from './ResourceLegend';

const statisticStatus = Object.keys(STATISTICS_STATUS_ENUM);
function StatsResources() {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { entities } = useContext(ResourceContext);
  const { indicator_timespan, indicator_resource } =
    useContext(AuthContext).getOptions();
  const resources = entities.filter((resource) => {
    const resourceId = resource.id.toString();
    return indicator_resource.includes(resourceId);
  });
  const cutoffTime = new Date(Date.now() - indicator_timespan * 60 * 60 * 1000);
  const ctxStatistic = useContext(StatisticContext);
  const getChartData = (resource) =>
    ctxStatistic.entities[0]?.resource_section
      .filter((e) => {
        const filter_resource = e.resource_info.id === resource.id;

        if (!statisticStatus.includes(e.status)) return false;
        if (!e.created_at_list) return filter_resource;

        const createdAtArray = e.created_at_list.map(
          (timestamp) => new Date(timestamp.toString().trim()),
        );

        const isRecent = createdAtArray.some((date) => date >= cutoffTime);

        return indicator_timespan
          ? filter_resource && isRecent
          : filter_resource;
      })
      .sort(
        (a, b) =>
          STATISTICS_STATUS_ENUM[a.status] - STATISTICS_STATUS_ENUM[b.status],
      );
  return (
    <>
      {!!resources.length && <ResourceLegend />}
      {resources.map((resource) => {
        const chartData = getChartData(resource);
        return (
          <Grid key={resource.id}>
            <Grid.Col xs={12}>
              <Card withBorder p="xl" radius="md">
                <Grid>
                  <Grid.Col md={10} lg={10}>
                    <Title order={2} size={theme.fontSizes.lg}>
                      {t('StatsControlsBarchart.TimeInterval', {
                        name: resource.name,
                        count: indicator_timespan,
                      })}
                    </Title>
                  </Grid.Col>
                  <Grid.Col xs={8} md={8} lg={8}>
                    <StatsRequestedResources chartData={chartData} />
                  </Grid.Col>
                  <Grid.Col xs={4} md={4} lg={4}>
                    <StatsPie chartData={chartData} />
                  </Grid.Col>
                </Grid>
              </Card>
            </Grid.Col>
          </Grid>
        );
      })}
    </>
  );
}

export default StatsResources;
